let ops = [];


export default {
    ops
}